"use client";
import React, { useRef, useState } from "react";

export default function AudioPlayer() {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [playing, setPlaying] = useState(false);
  const [showButton, setShowButton] = useState(true);

  const handlePlay = () => {
    if (audioRef.current) {
      audioRef.current.muted = false;
      audioRef.current.play();
      setPlaying(true);
      setShowButton(false);
    }
  };

  return (
    <>
      <audio ref={audioRef} src="/crypto.mp3" loop />
      {showButton && (
        <button
          onClick={handlePlay}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "rgba(0,0,0,0.4)",
            border: "none",
            borderRadius: "50%",
            width: 64,
            height: 64,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 20,
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          }}
          aria-label="播放音乐"
        >
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="rgba(255,255,255,0.3)" />
            <polygon points="13,10 24,16 13,22" fill="#fff" />
          </svg>
        </button>
      )}
    </>
  );
}
